import "./css/products.css";
import { useParams } from "react-router-dom";
import { MdDownload } from "react-icons/md";
import TabNavItem from "../components/TabNavItem";
import TabContent from "../components/TabContent";
import "../components/Tabs.css";
import React, { useState } from "react";

import SubHeader from "../components/subHeader2";
import i18next from "../config/lang/i18next";

import GIF1500 from "./img/gif1500.png";
import EVISX1 from "./img/evisx1.png";
import CV1500 from "./img/CV-1500.png";
import CF1500 from "./img/cf1500.png";
import CFH290 from "./img/CF-H290LI.png";
import GIFH290 from "./img/GIF-H290.png";
import OERAW from "./img/올림푸스.png";

const options = [
  {id:"d1",title:"EVIS X1"},
  {id:"d2",title:"CV-1500"},
  {id:"d3",title:"GIF-EZ1500"},
  {id:"d4",title:"CF-EZ1500DL/I"},
  {id:"d5",title:"GF-H290L/I"},
  {id:"d6",title:"GIF-H290"},
  {id:"d7",title:"OER-AW"}
];


const Products = () => {
  let { id } = useParams();
  const [activeTab, setActiveTab] = useState(id);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(id);
  const toggling = () => setIsOpen(!isOpen);
  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
    console.log(selectedOption);
  };
  const pdfDownload = () => {
    // using Java Script method to get PDF file
    fetch('SamplePDF.pdf').then(response => {
        response.blob().then(blob => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = 'SamplePDF.pdf';
            alink.click();
        })
    })
  }
  return (
    <div className="wrapper device">
      <SubHeader />
   
      <div className="Tabs2">
        <ul className="nav">
          <TabNavItem
            title="EVIS X1"
            id="d1"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <TabNavItem
            title="CV-1500"
            id="d2"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <TabNavItem
            title="GIF-EZ1500"
            id="d3"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <TabNavItem
            title="CF-EZ1500DL/I"
            id="d4"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          <TabNavItem
            title="GIF-H290"
            id="d5"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          <TabNavItem
            title="GF-H290L/I"
            id="d6"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          <TabNavItem
            title="OER-AW"
            id="d7"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </ul>
        <div className="dropdown_container">
 
 <div>
   <div className="">
     <select value={selectedOption} onChange={(e)=>{console.log(e.target.value);setSelectedOption(e.target.value);
       setActiveTab(e.target.value);
     }}>
     {options.map((option) => (
      
         <option
           value={option.id}                    
         >
           {option.title}
         </option>
     ))}
     </select>
   </div>
 </div>
</div>

        <div className="device_desc">
          <TabContent id="d1" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={EVISX1} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/EVIS-X1_e-Brochure_EN_86578.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>
                    {i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
<h3>Texture and Color Enhancement Imaging (TXI)

</h3>
<p>
{i18next.t("d1-1")}
</p>

<h3>
Computer-Aided Detection (CADe)

</h3>
<p>
{i18next.t("d1-2")}
</p>

<h3>
Narrow Band Imaging (NBI)

</h3>
<p>
{i18next.t("d1-3")}
</p>

<h3>
Red Dichromatic Imaging (RDI)
</h3>
<p>
{i18next.t("d1-4")}
</p>

<h3>Extended Depth of Field (EDOF)</h3>
<p>
{i18next.t("d1-5")}
</p>
</div>
            </div>
          </TabContent>
      
          <TabContent id="d2" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={CV1500} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/CV-1500_Product-Leaflet_M00250EN_A4_Final.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
                    <div>
  <h3>
  A Unified Platform with 5 LED Spectrum Technology
  </h3>

  <p>
  {i18next.t("d2-1")}
</p>

  <h3>Enhanced Observations</h3>
  <p>
  {i18next.t("d2-2")}<br>
  </br> 
  <br></br>
  {i18next.t("d2-3")}<br>
  </br>
  {i18next.t("d2-4")}<br>
</br>
{i18next.t("d2-5")}</p>
<h3>Intuitive, User-friendly Functions</h3>
<p>{i18next.t("d2-6")}</p>
 </div>
</div>
            </div>
          </TabContent>

          <TabContent id="d3" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={GIF1500} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/M00252EN_GIF-EZ1500_Product-Leaflet_A4_86592.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
                    <div>
<h3>EDOF Technology</h3>
<p>
{i18next.t("d3-1")}

</p>
<h3>Full Focus</h3>
<p>
{i18next.t("d3-2")}
</p>
<h3>High Magnification with the Ease of Dual Focus</h3>
<p>
{i18next.t("d3-3")}
</p>
<h3>Other Features</h3>

<p>{i18next.t("d3-4")}</p>
<p>· ErgoGrip</p>
<p>· WaterJet</p>
<p>{i18next.t("d3-5")}</p>
 </div>
</div>
            </div>
          </TabContent>


          <TabContent id="d4" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={CF1500} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/CF-EZ1500DL_Product-Leaflet_M00254EN_A4_.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
                    <div>
<h3>EDOF Technology</h3>
<p>
{i18next.t("d4-1")}
</p>
<h3>Full Focus</h3>
<p>
{i18next.t("d4-2")}
</p>
<h3>
High Magnification with the Ease of Dual Focus
</h3>
<p>
{i18next.t("d4-3")}
</p>
<h3>Other Features</h3>
<p>{i18next.t("d4-4")}</p>
<p>· ErgoGrip</p>
<p>{i18next.t("d4-5")}</p>
<p>{i18next.t("d4-6")}</p>
<p>{i18next.t("d4-7")}</p>
<p>· WaterJet</p>
<p>{i18next.t("d4-8")}</p>
</div>
</div>
            </div>
          </TabContent>


          <TabContent id="d5" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={GIFH290} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/catalog_GIF-H290.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
                    <div>
<h3>
HDTV Image Quality
</h3>
<p>
{i18next.t("d5-1")}
</p>

<h3>
  NBI (Narrow Band Imaging)
</h3>
<p>
{i18next.t("d5-2")}
</p>
<h3>Slim Design</h3>
<p>{i18next.t("d5-3")}</p>
<h3>Small Bending Section</h3>
<p>{i18next.t("d5-4")}</p>
<h3>
  Waterproof One-touch Connector
</h3>
<p>
{i18next.t("d5-5")}
</p>

</div>
</div>
            </div>
          </TabContent>


          <TabContent id="d6" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={CFH290} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/catalog_CF-H290LI.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
                    <div>
<h3>
  HDTV Image Quality
</h3>
<p>
{i18next.t("d5-1")}
</p>

<h3>
  NBI (Narrow Band Imaging)
</h3>
<p>
{i18next.t("d5-2")}
</p>
<h3>RIT (Responsive Insertion Technology)</h3>
<p>
{i18next.t("d5-3")}
</p>
<h3>Water Jet</h3>
<p>
{i18next.t("d5-4")}
</p>
<h3>Waterproof One-touch Connector</h3>
<p>
{i18next.t("d5-5")}
</p>

</div>
</div>
            </div>
          </TabContent>


          <TabContent id="d7" activeTab={activeTab}>
            <div className="device_img">
              
              <img src={OERAW} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns">
                <a href="/catalog/OER-AW.pdf" target="_blank" download>
                  <button style={{background:"rgb(77 133 210)", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>
              <div className="">
                      <div className="view_section_tit">
                      <h2>Features</h2>
                    </div>
                    <div>
  <h3>Two-scope reprocessing</h3>
    <p>{i18next.t("d5-1")}</p>
  <h3>Ultrasonic cleaning and high-pressure cleaning</h3>
    <p>
    {i18next.t("d5-2")}
    </p>
  <h3>Visible process</h3>
    <p>
    {i18next.t("d5-3")}</p>

  <h3>Printer for traceability</h3>
    <p>{i18next.t("d5-4")}</p>
  <h3>Case for accessories</h3>
    <p>
    {i18next.t("d5-5")}
    </p>
  </div>
</div>
            </div>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default Products;
